import React, { forwardRef } from "react";
import PropTypes from "prop-types";

// @mui material components
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const MDCheckbox = forwardRef(({ label, ...rest }, ref) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...rest}
          inputProps={{
            "aria-label": label,
          }}
        />
      }
      label={label}
      sx={{ margin: "3px" }}
    />
  );
});

export default MDCheckbox;

MDCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
};
